<div class="grow overflow-y-auto">
    <valben-table
        [loading]="loading()"
        [columns]="cols"
        [values]="tableValues()"
        [refresh]="refresh"
        (editEvent)="edit($event)"
        [addLabel]="'Dodaj kategoriju'"
        (addEvent)="add()"
    >
    </valben-table>
</div>
